// extracted by mini-css-extract-plugin
module.exports = {"ShopperBrowse":"ShopperBrowse_ShopperBrowse__3X9vu","StoreCards":"ShopperBrowse_StoreCards__t67Xu"};